module.exports = __webpack_public_path__ + "static/media/pointer.c2b51339.svg";